<template>
  <div class="dashboard-container">
    <div class="mb-2 page-title">
      <i class="bi bi-file-earmark-spreadsheet"></i> Impor Atlet dari Excel
    </div>

    <p class="impor__hint">
      Tambahkan banyak atlet sekaligus. Unduh templatenya dulu, isi, lalu
      unggah kembali di sini.
    </p>

    <!-- Langkah 1 -->
    <section class="ui-card impor__blok">
      <div class="ui-card__body">
        <h2 class="impor__judul"><span class="impor__nomor">1</span> Unduh Template</h2>
        <p class="impor__teks">
          Templatenya sudah berisi judul kolom, satu baris contoh, dan lembar
          berisi daftar Kategori serta Kelompok Usia yang boleh dipakai.
        </p>
        <p class="impor__teks impor__teks--tegas">
          <i class="bi bi-info-circle"></i>
          Selalu unduh template yang baru. Judul kolom diperiksa saat
          mengunggah, dan berkas dari template lama akan ditolak &mdash;
          kolomnya bergeser, dan data bisa masuk ke kolom yang salah tanpa
          menimbulkan galat.
        </p>
        <button type="button" class="ui-btn ui-btn--secondary" :disabled="mengunduh" @click="unduhTemplate">
          <span v-if="mengunduh" class="ui-spinner"></span>
          <i v-else class="bi bi-download"></i>
          {{ mengunduh ? 'Menyiapkan…' : 'Unduh Template Excel' }}
        </button>
      </div>
    </section>

    <!-- Langkah 2 -->
    <section class="ui-card impor__blok">
      <div class="ui-card__body">
        <h2 class="impor__judul"><span class="impor__nomor">2</span> Data yang Berlaku untuk Semua Baris</h2>
        <!--
          Wilayah dan kontingen ditanyakan SEKALI di sini, bukan per baris
          di Excel. Kolom wilayah tersimpan sebagai id angka; meminta
          official mengetiknya mustahil, dan mencocokkan nama daerah dari
          ketikan bebas ("Kab. Bogor" / "Kabupaten Bogor" / "bogor") pasti
          menghasilkan pencocokan salah tanpa ada yang menyadarinya.
        -->
        <p class="impor__teks">
          Satu kontingen umumnya berasal dari satu daerah, jadi bagian ini
          cukup diisi sekali. Atlet yang beda daerah bisa disunting setelahnya.
        </p>

        <div class="impor__grid">
          <div class="ui-field">
            <label class="ui-label">Kontingen</label>
            <PilihCari
              v-model="form.contingent_id"
              :options="kontingen"
              placeholder="Pilih kontingen"
              cari-placeholder="Ketik nama kontingen…"
            />
          </div>

          <label class="ui-field">
            <span class="ui-label">Provinsi</span>
            <select v-model="form.province_id" class="ui-input" @change="muat('district')">
              <option value="">Pilih provinsi</option>
              <option v-for="w in provinsi" :key="w.id" :value="w.id">{{ w.name }}</option>
            </select>
          </label>

          <label class="ui-field">
            <span class="ui-label">Kabupaten/Kota</span>
            <select v-model="form.district_id" class="ui-input" :disabled="!form.province_id" @change="muat('subdistrict')">
              <option value="">{{ form.province_id ? 'Pilih kabupaten/kota' : 'Pilih provinsi dulu' }}</option>
              <option v-for="w in kabupaten" :key="w.id" :value="w.id">{{ w.name }}</option>
            </select>
          </label>

          <label class="ui-field">
            <span class="ui-label">Kecamatan</span>
            <select v-model="form.subdistrict_id" class="ui-input" :disabled="!form.district_id" @change="muat('ward')">
              <option value="">{{ form.district_id ? 'Pilih kecamatan' : 'Pilih kabupaten dulu' }}</option>
              <option v-for="w in kecamatan" :key="w.id" :value="w.id">{{ w.name }}</option>
            </select>
          </label>

          <label class="ui-field">
            <span class="ui-label">Kelurahan/Desa</span>
            <select v-model="form.ward_id" class="ui-input" :disabled="!form.subdistrict_id">
              <option value="">{{ form.subdistrict_id ? 'Pilih kelurahan/desa' : 'Pilih kecamatan dulu' }}</option>
              <option v-for="w in kelurahan" :key="w.id" :value="w.id">{{ w.name }}</option>
            </select>
          </label>
        </div>
      </div>
    </section>

    <!-- Langkah 3 -->
    <section class="ui-card impor__blok">
      <div class="ui-card__body">
        <h2 class="impor__judul"><span class="impor__nomor">3</span> Unggah Berkas</h2>

        <input
          ref="berkas"
          type="file"
          accept=".xlsx,.xls"
          class="ui-input"
          @change="pilihBerkas"
        />

        <p v-if="namaBerkas" class="impor__terpilih">
          <i class="bi bi-file-earmark-excel"></i> {{ namaBerkas }}
        </p>

        <button
          type="button"
          class="ui-btn ui-btn--primary ui-btn--lg"
          style="margin-top: 1rem"
          :disabled="!siap || mengunggah"
          @click="unggah"
        >
          <span v-if="mengunggah" class="ui-spinner"></span>
          <i v-else class="bi bi-upload"></i>
          {{ mengunggah ? 'Memproses…' : 'Impor Sekarang' }}
        </button>

        <p v-if="!siap" class="impor__belum">
          Lengkapi bagian 2 dan pilih berkas dulu.
        </p>
      </div>
    </section>

    <!-- Hasil -->
    <section v-if="hasil" class="ui-card impor__blok" :class="hasil.baik ? 'impor--baik' : 'impor--galat'">
      <div class="ui-card__body">
        <h2 class="impor__judul">
          <i :class="hasil.baik ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-triangle-fill'"></i>
          {{ hasil.pesan }}
        </h2>

        <!--
          Baris bermasalah ditulis SEMUA, dengan nomor barisnya.
          Kalau hanya ditulis "ada 12 baris salah", official harus menebak
          yang mana — dan menebak di berkas 200 baris berarti menyerah.
          Tidak ada satu pun atlet yang masuk saat ada galat, jadi mereka
          bisa memperbaiki lalu mengunggah ulang berkas yang sama.
        -->
        <div v-if="hasil.galat?.length" class="impor__galat">
          <div v-for="g in hasil.galat" :key="g.baris" class="impor__galat-baris">
            <strong>Baris {{ g.baris }}</strong>
            <span v-if="g.nama"> — {{ g.nama }}</span>
            <ul>
              <li v-for="(m, i) in g.masalah" :key="i">{{ m }}</li>
            </ul>
          </div>
        </div>

        <router-link v-if="hasil.baik" to="/admin/team-members" class="ui-btn ui-btn--secondary" style="margin-top: 1rem">
          Lihat Daftar Atlet
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
/**
 * Impor atlet massal dari berkas Excel.
 *
 * Dibagi tiga langkah bernomor, bukan satu formulir panjang: official yang
 * belum pernah memakainya perlu tahu bahwa templatenya harus diunduh dulu.
 * Tanpa penomoran, kotak unggah di bawah terlihat seperti bisa langsung
 * diisi berkas apa saja.
 */
import http from '@/services/http';
import { useToast } from 'vue-toastification';
import PilihCari from '@/components/ui/PilihCari.vue';

export default {
  name: 'ImporAtletPage',

  components: { PilihCari },

  setup() {
    return { toast: useToast() };
  },

  data() {
    return {
      kontingen: [],
      provinsi: [],
      kabupaten: [],
      kecamatan: [],
      kelurahan: [],
      form: {
        contingent_id: '',
        country_id: 1,
        province_id: '',
        district_id: '',
        subdistrict_id: '',
        ward_id: '',
      },
      berkas: null,
      namaBerkas: '',
      mengunduh: false,
      mengunggah: false,
      hasil: null,
    };
  },

  computed: {
    siap() {
      const f = this.form;
      return Boolean(
        this.berkas && f.contingent_id &&
        f.province_id && f.district_id && f.subdistrict_id && f.ward_id
      );
    },
  },

  mounted() {
    document.title = 'Impor Atlet';
    this.muatAwal();
  },

  methods: {
    async muatAwal() {
      try {
        const [k, p] = await Promise.all([
          http.get('/contingents/fetch-all'),
          http.get('/provinces'),
        ]);
        this.kontingen = this.isi(k);
        this.provinsi = this.isi(p);
      } catch (e) { /* pesan sudah dari interceptor */ }
    },

    isi(res) {
      const d = res?.data;
      return Array.isArray(d) ? d : d?.data ?? [];
    },

    /*
     * Pilihan di bawahnya DIKOSONGKAN saat induknya berubah.
     * Tanpa ini, mengganti provinsi meninggalkan kecamatan lama yang tidak
     * ada hubungannya — dan alamat atlet tersimpan salah tanpa peringatan.
     */
    async muat(tingkat) {
      try {
        if (tingkat === 'district') {
          this.form.district_id = ''; this.form.subdistrict_id = ''; this.form.ward_id = '';
          this.kabupaten = []; this.kecamatan = []; this.kelurahan = [];
          if (!this.form.province_id) return;
          this.kabupaten = this.isi(await http.get('/districts', { params: { province_id: this.form.province_id } }));
        }
        if (tingkat === 'subdistrict') {
          this.form.subdistrict_id = ''; this.form.ward_id = '';
          this.kecamatan = []; this.kelurahan = [];
          if (!this.form.district_id) return;
          this.kecamatan = this.isi(await http.get('/subdistricts', { params: { district_id: this.form.district_id } }));
        }
        if (tingkat === 'ward') {
          this.form.ward_id = '';
          this.kelurahan = [];
          if (!this.form.subdistrict_id) return;
          this.kelurahan = this.isi(await http.get('/wards', { params: { subdistrict_id: this.form.subdistrict_id } }));
        }
      } catch (e) { /* pesan sudah dari interceptor */ }
    },

    pilihBerkas(e) {
      const f = e.target.files?.[0] || null;
      this.berkas = f;
      this.namaBerkas = f ? f.name : '';
      this.hasil = null;
    },

    async unduhTemplate() {
      this.mengunduh = true;
      try {
        const res = await http.get('/atlet/template-excel', { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', 'template-atlet-arspo.xlsx');
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) { /* pesan sudah dari interceptor */ }
      finally { this.mengunduh = false; }
    },

    async unggah() {
      this.mengunggah = true;
      this.hasil = null;

      const fd = new FormData();
      fd.append('berkas', this.berkas);
      Object.entries(this.form).forEach(([k, v]) => fd.append(k, v));

      try {
        const { data } = await http.post('/atlet/impor-excel', fd, { diamDiam: true });
        this.hasil = { baik: true, pesan: data.message };
        this.toast.success(data.message);
        this.berkas = null;
        this.namaBerkas = '';
        if (this.$refs.berkas) this.$refs.berkas.value = '';
      } catch (error) {
        this.hasil = {
          baik: false,
          pesan: error.friendlyMessage || 'Impor gagal.',
          galat: error.response?.data?.galat || [],
        };
      } finally {
        this.mengunggah = false;
      }
    },
  },
};
</script>

<style scoped>
.impor__hint { margin: 0 0 var(--space-5); font-size: var(--text-sm); color: var(--text-secondary); }
.impor__blok { margin-bottom: var(--space-5); }

.impor__judul {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin: 0 0 var(--space-3);
  font-size: var(--text-lg);
}

.impor__nomor {
  display: grid;
  place-items: center;
  width: 28px; height: 28px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  font-size: var(--text-sm);
  font-weight: 700;
}

.impor__teks--tegas {
  padding: .6rem .75rem;
  border-radius: 8px;
  background: rgba(217, 119, 6, .1);
  color: #b45309;
}

.impor__teks { margin: 0 0 var(--space-4); font-size: var(--text-sm); color: var(--text-secondary); }

.impor__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
}

@media (min-width: 700px) { .impor__grid { grid-template-columns: 1fr 1fr; } }

.impor__terpilih { margin: var(--space-3) 0 0; font-size: var(--text-sm); color: var(--text-brand); }
.impor__belum { margin: var(--space-2) 0 0; font-size: var(--text-xs); color: var(--text-muted); }

.impor--baik  { border-color: var(--success-500); }
.impor--galat { border-color: var(--danger-600); }

.impor__galat {
  margin-top: var(--space-4);
  max-height: 340px;
  overflow-y: auto;
  font-size: var(--text-sm);
}

.impor__galat-baris {
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--border-subtle);
}

.impor__galat-baris ul { margin: var(--space-1) 0 0; padding-left: var(--space-5); color: var(--danger-600); }
</style>
